<h1 class="title">Assign CAP to Project</h1>
<h5>&nbsp;</h5>
<div class="cas-wrapper">
    <acabim-card cardHeading="Select CAP to add"
                 [cardContent]="cap"
                 *ngIf="currentProject; else noProject">
    </acabim-card>
    <ng-template #cap>
        <div class="container">
            <div class="row py-4" *ngIf="!isLoading; else loadingView">
                <div class="col-11">
                    <p-treeSelect [(ngModel)]="selectedCap" [options]="groupedCap" selectionMode="checkbox" display="chip"
                                  placeholder="Select CAP"></p-treeSelect>
                </div>
                <div class="col-1">
                    <button (click)="addCapToProject()" class="cas-button-action" [disabled]="!selectedCap.length">ADD</button>
                </div>
            </div>
        </div>
    </ng-template>

    <acabim-card cardHeading="CAP in Project" [cardContent]="table" *ngIf="currentProject"></acabim-card>
</div>

<ng-template #table>
    <div class="container" *ngIf="!isCapTableProcessing; else loadingView">
        <div class="row justify-content-center">
            <div class="col-12 col-xxl-8">
                <!-- if more than one cap library is present or if only a single library is present and it is not default, then we'll
                    display the multi library cap view, where CAP is grouped into its library -->
                <ng-container *ngIf="currentProjectCap.length > 1 || (currentProjectCap.length == 1 && currentProjectCap[0].omniClassNumber)">
                    <ng-container *ngTemplateOutlet="outerTable; context: {$implicit: currentProjectCap}"></ng-container>
                </ng-container>
                <!-- only default lib is present, no need to display the multi library view -->
                <ng-container *ngIf="currentProjectCap.length == 1 && !currentProjectCap[0].omniClassNumber">
                    <ng-container *ngTemplateOutlet="innerTable; context: {$implicit: currentProjectCap[0]}"></ng-container>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- The data table which lists multiple cap libraries -->
    <ng-template #outerTable let-capLibraries>
        <p-table [value]="capLibraries" dataKey="name" styleClass="p-datatable-sm">
            <ng-template pTemplate="body" let-capLibrary let-expanded="expanded">
                <tr>
                    <td>
                        <button type="button" pButton pRipple [pRowToggler]="capLibrary" class="p-button-rounded p-button-text p-button-secondary simple-button"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>
                        <b>{{capLibrary.name}}</b>
                        <!--suppress TypeScriptUnresolvedVariable -->
                        <span *ngIf="capLibrary.omniClassNumber"> ({{capLibrary.omniClassNumber}})</span>
                    </td>
                    <!--suppress TypeScriptUnresolvedVariable -->
                    <td *ngIf="capLibrary.omniClassNumber">
                        <!--suppress TypeScriptUnresolvedVariable -->
                        <button type="button" pButton (click)="deleteCapLibraryFromProject(capLibrary.omniClassNumber)">Remove</button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-capLibrary>
                <tr>
                    <td colspan="7">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-12 col-xxl-8">
                                    <ng-container *ngTemplateOutlet="innerTable; context: {$implicit: capLibrary}"></ng-container>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>

    <!-- The data table which lists cap in a single library -->
    <ng-template #innerTable let-capLibrary>
        <!--suppress TypeScriptUnresolvedVariable -->
        <p-table [value]="capLibrary.capId" styleClass="p-datatable-sm">
            <ng-template pTemplate="body" let-cap>
                <tr>
                    <td>{{cap}}</td>
                    <!--suppress TypeScriptUnresolvedVariable -->
                    <td *ngIf="!capLibrary.omniClassNumber">
                        <button type="button" pButton (click)="deleteCapFromProject(cap)">Remove</button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #noProject>
    <div class="cas-error">Please select a project to work with.</div>
</ng-template>
